import { useMutation } from '@tanstack/react-query';
import { AxiosInstance } from 'axios';
import config from 'config';
import { useNavigate } from 'react-router-dom';

import { useAxios } from '../../context/AxiosContextProvider';

export interface inviteChainManagerArguments {
  axios: AxiosInstance;
  id: number;
  firstname: string;
  lastname: string;
  email: string;
}

async function create({ axios, id, firstname, lastname, email }: inviteChainManagerArguments): Promise<object> {
  const { data } = await axios.post(`${config.apiBaseUrl}/op/v1/chain/user/invite `, {
    chain_id: Number(id),
    firstname,
    lastname,
    email,
  });
  return data;
}

export default function useInviteChainManagerMutation(id: number) {
  const axios = useAxios();
  const navigate = useNavigate();

  return useMutation({
    mutationFn: ({ firstname, lastname, email }: { firstname: string; lastname: string; email: string }) =>
      create({ axios, id, firstname, lastname, email }),
    onSuccess: () => {
      navigate(`/app/op/chains/${id}`);
    },
  });
}
